/**
 * The key carries the user id: the liked set is that user's, so an account
 * switch must not reuse the previous answer.
 */
const likesKeys = {
  liked: (userId: string) => ['preset-likes', 'liked', userId],
};

export default likesKeys;
